import React from "react";

import styles from "./HomePage.module.css";

const HomePage = function (props) {
  return (
    <main className={styles.main}>
      <section className={`${styles.section} ${styles["cta-container"]}`}>
        <div className={styles["cta-logo"]}>
          <div className={styles["logo-half-red"]}>
            <svg
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              viewBox="0 0 361 271"
            >
              <path
                d="M360.5,180.5c0-49.71-40.29-90-90-90c-49.7,0-90,40.29-90,90
	c0,49.7-40.29,90-90,90c-49.7,0-90-40.3-90-90c0-99.42,80.59-180,180-180S360.5,81.08,360.5,180.5z"
              />
            </svg>
          </div>
          <div className={styles["logo-half-blue"]}>
            <svg
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              viewBox="0 0 361 271"
            >
              <path
                d="M360.5,180.5c0-49.71-40.29-90-90-90c-49.7,0-90,40.29-90,90
	c0,49.7-40.29,90-90,90c-49.7,0-90-40.3-90-90c0-99.42,80.59-180,180-180S360.5,81.08,360.5,180.5z"
              />
            </svg>
          </div>
          <h1 className={styles["logo-text"]}>Kcards</h1>
        </div>
        <p className={styles["logo-slogan"]}>Flash cards made easy.</p>
        <p className={styles["demo-text"]}>
          This is a demo app. <br />
          Feel free to make an account and explore. <br />
          Search a word, save card, check collection, review.
        </p>
      </section>
    </main>
  );
};

export default HomePage;
